import { render, staticRenderFns } from "./UnifiedSearchModal.vue?vue&type=template&id=e675c164&scoped=true"
import script from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
export * from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./UnifiedSearchModal.vue?vue&type=style&index=0&id=e675c164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e675c164",
  null
  
)

export default component.exports